<div nz-row>
  <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" class="cs-logo">
    <div>
      @if (!isCloudstaffDomain) {
        <img src="../../assets/images/primary-logo.svg" />
        }@else {
        <img src="../../assets/images/cloudstaff-logo.svg" />
      }

    </div>
  </div>
</div>
<div nz-row style="margin-bottom: 20px">
  <div
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="24"
    nzLg="24"
    class="main-content-header"
    >
    <div class="content-jx-image">
      @if (isProfilePhotoView) {
        <nz-avatar [nzSize]="180"
          nzIcon="user"
          [nzSrc]="header?.profilePicture === null ? '' : header?.profilePicture"
         />
      }
      <label>CV-{{ cvId() }}</label>
    </div>
    <div class="content-jx-name">
      @if (isJXIDView) {
        <span class="jx-id">{{ header?.jxId }}</span>
      }
      <label
        >{{ isFirstNameView ? header?.firstName : '' }}
        {{ isLastNameView ? header?.lastName : '' }}
        @if(header?.csUserName !== null && isCSUsernameView){
          <span> ({{ header?.csUserName }}) </span>
        }
      </label>
      <span class="jx-title">{{ latestJobTitle() }}</span>
      @if (isJobseekingstatusView && header?.jobSeekingStatus !== null) {
        <div
          class="jx-job-seeking-status"
          >
          <span
            ><i class="fa-regular fa-circle-check"></i> Actively looking for
            jobs</span
            >
          </div>
        }
      </div>
    </div>
  </div>
